import SendMailIcon from "@assets/images/send-mail.svg";
import { Box, Button } from "@material-ui/core";
import { ItemTab } from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import MyTypography from "@saleor/components/MyTypography";
import SingleSelectField from "@saleor/components/SingleSelectField";
import {
  ListOfSaleOrderPendingSapQuery,
  SapPendingOrderReportInput
} from "@saleor/graphql";
import {
  ORDER_REPORT_LANGUAGE_CHOICES,
  OrderReportLanguageEnum
} from "@saleor/OrderConfirm/const";
import TableData from "@saleor/PendingOrder/components/OrderListTableAdmin/Table";
import { PendingOrderListSortField } from "@saleor/PendingOrder/urls";
import { SortPage } from "@saleor/types";
import classNames from "classnames";
import lodash_uniq from "lodash/uniq";
import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import ModalSendMail from "../ModalSendMail";
import useStyles from "./styles";
interface OrderListTableAdminProps extends SortPage<PendingOrderListSortField> {
  data: ListOfSaleOrderPendingSapQuery["listOfSaleOrderPendingSap"];
  listLineOrder?: any[];
  setListLineOrder?: (value) => void;
  loading?: boolean;
  settings?: any;
  activeTab?: ItemTab;
  filterData?: SapPendingOrderReportInput;
  isCustomer?: boolean;
  isOrderTracking?: boolean;
  reportLanguage?: OrderReportLanguageEnum;
  onChangeReportLanguage?: (value: OrderReportLanguageEnum) => void;
}

interface currentSoldType {
  soldTo: string;
  soldToName: string;
  saleOrg: string;
  saleOrgList?: string[];
  productGroup: string[];
  bu?: string;
}

const OrderListTableAdmin: React.FC<OrderListTableAdminProps> = ({
  data,
  sort,
  onSort,
  filterData,
  isCustomer,
  isOrderTracking,
  reportLanguage,
  onChangeReportLanguage
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [openSendMail, setOpenSendMail] = useState<boolean>(false);
  const [currentSoldTo, setCurrentSoldTo] = useState<currentSoldType>({
    soldTo: "",
    soldToName: "",
    saleOrg: "",
    saleOrgList: [""],
    productGroup: [""],
    bu: ""
  });

  const handleOpenModalSendMail = item => {
    let filterProductGroups: string[];

    if (item.productGroups.length > 0) {
      filterProductGroups = item.productGroups.map(
        product => product.materialGroup
      );
    } else {
      filterProductGroups.push("");
    }

    const orderLinesList = [];
    item.productGroups.forEach(item =>
      item.orderLines.forEach(order => orderLinesList.push(order))
    );

    const saleOrgLists = orderLinesList.map(item =>
      item.saleOrg?.split("-")?.[0]?.trim()
    );

    const productGroups = filterData?.bu === "CIP" ? [""] : filterProductGroups;
    setOpenSendMail(true);
    setCurrentSoldTo({
      soldTo: item.soldTo,
      soldToName: item.soldToName,
      saleOrg: item.productGroups[0].orderLines[0].saleOrg,
      saleOrgList: lodash_uniq(saleOrgLists),
      productGroup: productGroups,
      bu: filterData?.bu
    });
  };

  const handleChangeReportLanguage = (
    event: React.ChangeEvent<{ value: string }>
  ) => {
    const language = (event?.target?.value ?? "") as OrderReportLanguageEnum;
    onChangeReportLanguage(language);
  };

  return (
    <>
      <div className={classes.root} data-testid="order-list-table-admin">
        {!!reportLanguage && data.length > 0 && (
          <div className={classes.tableFilterContainer}>
            <SingleSelectField
              choices={ORDER_REPORT_LANGUAGE_CHOICES}
              value={reportLanguage}
              className={classes.selectLanguageForm}
              InputProps={{
                inputProps: { "data-testid": "reportLanguage-select" },
                classes: { root: classes.selectLanguageField }
              }}
              onChange={handleChangeReportLanguage}
              name={"language"}
            />
          </div>
        )}
        {data.map(item => (
          <Box className={classes.soldToWrapper}>
            <Box className={classes.soldToTitle}>
              <MyTypography
                variant="subtitle1"
                className={classes.displayInline}
              >
                Sold To:{" "}
                <MyTypography variant="body1" className={classes.displayInline}>
                  {`${item.soldTo} ${item.soldToName}`}
                </MyTypography>
              </MyTypography>
              {!isCustomer ? (
                <Button
                  variant="outlined"
                  color="secondary"
                  className={classNames(classes.sendMailBtn)}
                  onClick={() => {
                    handleOpenModalSendMail(item);
                  }}
                >
                  <SVG src={SendMailIcon} className={classes.sendMailIcon} />
                  <MyTypography variant="body2">
                    {intl.formatMessage({
                      defaultMessage: "Send Email"
                    })}
                  </MyTypography>
                </Button>
              ) : null}
            </Box>
            <TableData
              productGroups={item.productGroups.filter(
                item => item.orderLines.length > 0
              )}
              sort={sort}
              onSort={onSort}
            />
          </Box>
        ))}
      </div>
      <ModalSendMail
        soldToCode={currentSoldTo.soldTo}
        soldToName={currentSoldTo.soldToName}
        saleOrg={currentSoldTo.saleOrg}
        saleOrgList={currentSoldTo.saleOrgList}
        productGroup={currentSoldTo.productGroup}
        bu={currentSoldTo.bu}
        isOrderTracking={isOrderTracking}
        open={openSendMail}
        onClose={() => setOpenSendMail(false)}
        filterData={filterData}
        reportLanguage={reportLanguage}
      />
    </>
  );
};

export default OrderListTableAdmin;
